import { type InternationalWire } from "./providers";

import type Wire from "../../../../Wire";

export const getCreatedAt = (wire: Wire | InternationalWire) =>
  (wire as InternationalWire)?.createdAt || (wire as Wire).created_at;

export const getDate = (wire: Wire | InternationalWire) =>
  (wire as InternationalWire)?.updatedAt ||
  (wire as Wire).processed_at ||
  (wire as Wire).created_at;

export const getDisplayState = (wire: Wire | InternationalWire) => {
  if ("display_state" in wire) {
    return wire.display_state;
  }
  switch (wire.state) {
    case "analyzing":
    case "pending":
    case "review":
    case "processed":
    case "processing":
      return "Submitted";
    case "awaiting_approval":
      return "Pending Approval";
    case "rejected_approval":
      return "Rejected Approval";
    case "canceled":
      return "Cancelled";
    case "rejected":
      return "Rejected";
    default:
      return "Unknown";
  }
};

export const getCountryCodeFromBic = (bic: string) => {
  const countryCode = bic.slice(4, 6);
  return countryCode;
};
